module.exports = __webpack_public_path__ + "img/pic_7.07e4586f.png";